import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirst'
})
export class CapitalizeFirstPipe implements PipeTransform {

    transform(value: string, words: boolean): string {
        if (value) {
            if (words) {
                return value.toLowerCase().replace(/\b\w/g, first => first.toLocaleUpperCase());
            } else {
                value = value.toLowerCase();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        }

        return value;
    }

}
